import {Component, AfterViewInit, OnInit} from '@angular/core';
import { MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { AbstractControl, UntypedFormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import {CollectionService} from '../../services/collection.service';
import {CollectionItem, ReportType} from '../../services/collection.model';
import {CMSService} from '../../../../shared/components/cms/service/cms.service';
import { NgClass, AsyncPipe } from '@angular/common';
import { SavingInProgressComponent } from '../../../../shared/components/saving-in-progress/saving-in-progress.component';

@Component({
    selector: 'app-add-collections.component',
    templateUrl: './add-collections.component.html',
    styleUrls: ['./add-collections.component.scss'],
    imports: [ReactiveFormsModule, NgClass, FormsModule, MatDialogClose, SavingInProgressComponent, AsyncPipe]
})
export class AddCollectionsComponent implements OnInit, AfterViewInit {
  singleDataTitle;
  singleDataDescription;
  startEndDataTitle;
  startEndDataDescription;
  multiDataTitle;
  multiDataDescription;
  nameExists: boolean ;
  collectionItems: CollectionItem[] = [];
  NodeData;
  collectionName = new UntypedFormControl('', [
    Validators.required,
    Validators.maxLength(255),
    this.validateExistingNames.bind(this)]);
  selectedOptions = {
    SINGLE_STEP: true,
    SIMPLE: false,
    FULL: false,
    selectedKey: 'SINGLE_STEP'
  };
  savingInProgress: boolean;

  constructor(
      private dialogRef: MatDialogRef<AddCollectionsComponent>,
      private collectionService: CollectionService,
      public cmsService: CMSService
  ) {}

  CMSData() {
    this.singleDataTitle = "Single Data Point";
    this.singleDataDescription = this.cmsService.cmsCall('1FKXEuGbkY9zkCnzGyUq0a', 'entry');
    this.startEndDataTitle = "Start and End Data Points";
    this.startEndDataDescription = this.cmsService.cmsCall('4OuXw3PSKAKV0u44uGfi7M', 'entry');
    this.multiDataTitle = "Multi Data Points";
    this.multiDataDescription = this.cmsService.cmsCall('Jd64vvW9IxjjlE5YFBLhz', 'entry');
  }

  capitalisePlaceHolder(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  ngOnInit() {
    this.collectionService.getCollections().subscribe((response) => {
      const collections = response as CollectionItem[];
      this.collectionItems = collections.filter(collection => !collection.disabled);
    });
    this.CMSData();
    this.NodeData = this.dialogRef._containerInstance._config.data;
    console.log('NodeData: ', this.NodeData);
  }

  ngAfterViewInit() {
    const radios = document.getElementsByName('options');
    const label = radios[0].parentElement as HTMLLabelElement;
    this.changeItems(label);
  }

  save() {
    this.dialogRef.close();
    this.savingInProgress = true;
    const collection = {
      featureName: this.collectionName.value,
      featureType: this.selectedOptions.selectedKey
    }
    this.collectionService.create(collection)
        .subscribe((response) => {
          this.savingInProgress = false;
          if (response) {
            this.dialogRef.close();
            if (this.NodeData?.callFromNode) {
              this.collectionService.triggerAddCollection(response);
              return false;
            }
            this.collectionService.showToast({
              type: 'success',
              title: 'Collection Added',
              message: `${ReportType[collection.featureType]} collection "${collection.featureName}" successfully added.`
            });
          } else {
            this.collectionService.showToast({
              type: 'error',
              title: 'Collection Not Added',
              message: `${ReportType[collection.featureType]} collection "${collection.featureName}" not added.`
            });
          }
        });
  }

  closePopup() {
    this.dialogRef.close();
  }

  validateExistingNames(control: AbstractControl): { [key: string]: boolean } | null {
    for (let i = 0; i < this.collectionItems.length; i++) {
      const obj = this.collectionItems[i];
      if (Object.values(obj).includes(control.value)) {
        this.nameExists = true;
        control.setErrors({'nameExists': true});
        return {'nameExists': true};
      }
    }
    if (this.nameExists) {
      control.setErrors(null);
      this.nameExists = false;
    }
    return null;
  }

  changeBorderColor(event: any) {
    const target = event.target as HTMLInputElement;
    const parentLabel = target.closest('.collection-radios') as HTMLElement;
    const allLabels = document.querySelectorAll('.collection-radios');
    allLabels.forEach((label: HTMLElement) => {
      if (label !== parentLabel) {
        label.style.borderColor = '#D4D9E2';
        label.style.backgroundColor = '';
      }
    });
    if (target.checked) {
      this.changeItems(parentLabel);
    }
  }

  isInvalid() {
    return this.collectionName.invalid && this.collectionName.touched;
  }

  isValid() {
    return this.collectionName.valid && this.collectionName.touched;
  }

  changeItems(label: HTMLElement) {
    label.style.borderColor = '#95E1F5';
    label.style.backgroundColor = '#F5FBFD';
  }
}
